import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, Card, CardBody, FormGroup, Spinner } from 'reactstrap';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import Select, { components, ValueContainerProps } from 'react-select';
import './Cropping.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import uuid from 'react-uuid';
import Radio from '../Radio/Radio'
import MapView from '../Map/MapView';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import ItemTypeListView from '../ItemsView/ItemTypeListView';
import MapType from '../ItemPopup/MapType';
import Validate from '../Validate/Validate';
import CropAreaItemView from './CropAreaItemView';
import ToggleSwitch from '../ThreeStateToggle/ToggleSwitch';
import Documents from '../Uploads/Documents';
import ItemTypeListViewForMap from '../ItemsView/ItemTypeListViewForMap';
import ActionsToConsider from '../FarmApt/ActionsToConsider';
import Action from '../Action/Action';
import WholeFarmActionView from '../ItemsView/WholeFarmActionView';
import RiskSummary from '../ItemsView/RiskSummary';
import Draggable, { DraggableCore } from 'react-draggable';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import HistoricalActions from '../ItemsView/HistoricalActions'; import { apiGet,apiPost } from "../Utilities/Hooks/apiWrapper";

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}


const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const Cropping = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const roleName = localStorage.getItem("roleName");
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false);
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const isAddEditItem = localStorage.getItem("isAddEditItem");
    const [isNextButtonVisible, setIsNextButtonVisible] = useState(false); const { height, width } = useWindowDimensions();
    const [riskSummaryPopup, setRiskSummaryPopup] = useState({ showriskSummary: false }); const [isThisPageCompleted, setIsThisPageCompleted] = useState(false); const [actionsCount, setActionsCount] = useState(0);
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId")); const [toggleSwitch, setToggleSwitch] = useState('map & details'); const [itemDeletesaving, setItemDeleteSaving] = useState('');
    const [itemDeleteCropRecordsaving, setItemDeleteCropRecordSaving] = useState('');
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId")); const [cropAreaSaving, setCropAreaSaving] = useState(''); const [cropRecordSaving, setCropRecordSaving] = useState('');
    const [loading, setLoading] = useState(true); const [filterList, setFilterList] = useState(false); const [croppingStartingMonthSaving, setCroppingStartingMonthSaving] = useState(false);
    const [cropping, setCropping] = useState({
        outlineList: [], outlineItemTypes: [], itemList: [], tempItemList: [], itemTypes: [], section: 'Cropping', sectionName: 'Cropping and Cultivation', sectionObj: {}, isWizardCompleted: false, grazedHarvested: [], stockTypeFed: [],
        cultivationMethod: [], sectionComment: '', cultivationMethodForRedrilling: [], months: [], monthMultiSelect: [], crops: [], cropAreaRecordItems: [], cropAreaRecordTempItems: [], year: [], outlineCenter: {}
    }); const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0, isSmallEnterpriseShow: false })
    const [actionPopup, setActionPopup] = useState({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [wholeFarmActionPopup, setWholeFarmActionPopup] = useState({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLmuPage: false, isCenterReq: false, isFarmCenterEditable: false, isLMUPage:false,
        isFarmOutlineEditable: false, zoomLevel: 15, polyType: '', itemsEditable: false, highlighteditemId: 0, isClear: false,showLabel:false
    });
    const [groupByCropArea, setGroupByCropArea] = useState(true);
    
    const [toggleItemTypeListState, setToggleItemTypeListState] = useState({ isOpen: true, isIconUp: false });
    const [toggleItemTypeState, setToggleItemTypeState] = useState({ itemTypeId: 0, isOpen: false, isIconUp: false });
    const [typeid, setTypeId] = useState(0); const [itemPopupItemField, setItemPopupItemField] = useState({
        itemTypeId: 0
    });
    const [cropAreaPopup, setCropAreaPopup] = useState({
        showCropAreaPopup: false, mapitem: [], farmId: farmId, id: 0,effectiveArea:0.0, markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', Name: '', color: '', Description: '', archiveItem: true, popupName:'Add Crop Area'
    });
    const [cropRecordPopup, setCropRecordPopup] = useState({
        showCropRecordPopup: false, Name: '', id: 0, cropAreaId: 0, Year: 0, grazedHarvested: 0, CropType: '', irrigated: false, otherCropType: '', cropYield: 0,
        cultivationMethod: 0, timeOnCrop: 0, cultivationMethodRedrilling: 0, otherCropSown: '', stockTypeFed: 0, mitigationsToReduceSedimentSoilRunoff: '', cropTypeText: '', popupName: 'Add Crop Record'
    });
    const [cropAreaPopupMaptype, setCropAreaPopupMaptype] = useState({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });
    const [cropAreaDeletePopup, setCropAreaDeletePopup] = useState({ showCropAreaDeletePopup: false, id: 0 });
    const [cropRecordDeletePopup, setCropRecordDeletePopup] = useState({ showCropRecordDeletePopup: false, id: 0 });
    const [colOtherCropType, setColOtherCropType] = useState(false);

    const [monthSownList, setMonthSownList] = useState([]); const [monthSownListSelectedValues, setMonthSownListSelectedValues] = useState([]);
    const [monthSownSelectedValues, setMonthSownSelectedValues] = useState('');

    const [monthsGrazedHarvestedList, setMonthsGrazedHarvestedList] = useState([]); const [monthsGrazedHarvestedListSelectedValues, setMonthsGrazedHarvestedListSelectedValues] = useState([]);
    const [monthsGrazedHarvestedSelectedValues, setMonthsGrazedHarvestedSelectedValues] = useState('');

    const [monthBackIntoPastureList, setMonthBackIntoPastureList] = useState([]); const [monthBackIntoPastureListSelectedValues, setMonthBackIntoPastureListSelectedValues] = useState([]);
    const [monthBackIntoPastureSelectedValues, setMonthBackIntoPastureSelectedValues] = useState('');
    const [croppingStartingMonth, setCroppingStartingMonth] = useState(''); const [croppingStartingMonthList, setcCroppingStartingMonthList] = useState([]);
    const [disableViewOptions, setDisableViewOptions] = useState(false); const [currentYear, setCurrentYear] = useState(0);

    const [masterCropAreaList, setMasterCropAreaList] = useState([]);
    const [tempItemList, setTempItemList] = useState([]);
    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])


    const handleWholeActionClose = () => {
        setWholeFarmActionPopup({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    const handleCroppingStartingMonthSubmit = async (event) => {
        setCroppingStartingMonthSaving(true);
        const response = await apiGet(
        '/api/cropping/UpdateCroppingStartingMonth/', {
        params: {
            farmId: farmId, month: croppingStartingMonth.value
        }
        });
        if (response.data.status)
        {
            setCroppingStartingMonthSaving(false);
        }
    }

    const refreshItemDetails = async () => {
        const response = await apiGet(
            '/api/cropping/GetCropping/', {
            params: {
                farmId: farmId
            }
        }
        );
        setCropping({
            ...cropping, itemTypes: response.data.itemTypes, outlineCenter: response.data.outlineCenter, outlineList: response.data.outlineList, itemList: response.data.cropAreaItems, tempItemList: response.data.cropAreaItems,
            cropAreaRecordItems: response.data.cropAreaRecordItems,cropAreaRecordTempItems: response.data.cropAreaRecordItems, outlineItemTypes: response.data.outlineItemTypes
        });
    }
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/cropping/GetCropping/', {
                params: {
                    farmId: farmId
                }
            }
            );
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                if (section.length > 0) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            if (response.data.wizard.isCroppingCultivationSaved) {
                setIsThisPageCompleted(true);
            }
            else {
                setIsThisPageCompleted(false);
            }
            setActionsCount(response.data.actionCount);
            setShow_HistoricalActions(response.data.show_HistoricalActions);
            setShow_SectionComment(response.data.show_SectionComment);
            let d = new Date();
            setCurrentYear(d.getFullYear());
            response.data.cropAreaItems.forEach((item) => {
                item.nonContiguousItems = [];
                response.data.cropAreaItems.map(nc => {
                    if (nc.cropAreaItemId === item.itemId) {
                        item.nonContiguousItems.push(nc);
                    }
                })

            })
            setTempItemList(response.data.cropAreaItems);
            setCropping({
                ...cropping, itemTypes: response.data.itemTypes, outlineList: response.data.outlineList, itemList: response.data.cropAreaItems, tempItemList: response.data.cropAreaItems, sectionObj: response.data.section, isWizardCompleted: response.data.isFWFPCompleted,
                grazedHarvested: response.data.grazedHarvested, stockTypeFed: response.data.stockTypeFed, cultivationMethod: response.data.cultivationMethod, cultivationMethodForRedrilling: response.data.cultivationMethodForRedrilling,
                months: response.data.months, monthMultiSelect: response.data.monthMultiSelect, crops: response.data.crops, cropAreaRecordItems: response.data.cropAreaRecordItems,
                year: response.data.year, cropAreaRecordTempItems: response.data.cropAreaRecordItems, outlineItemTypes: response.data.outlineItemTypes, outlineCenter: response.data.outlineCenter, sectionComment: response.data.sectionComment
            });
            const content = ContentState.createFromBlockArray(convertFromHTML(response.data.sectionComment == null ? '' : response.data.sectionComment))
            setEditorState(EditorState.createWithContent(content));
            setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: !response.data.isFWFPCompleted, isIconUp: !response.data.isFWFPCompleted })
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel, polyType: '' });
            setMonthSownList(response.data.monthMultiSelect);
            setMonthsGrazedHarvestedList(response.data.monthMultiSelect);
            setMonthBackIntoPastureList(response.data.monthMultiSelect);
            setcCroppingStartingMonthList(response.data.monthMultiSelect);
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList })
            let croppingStartingMonthObj = response.data.monthMultiSelect.filter(x => x.value == response.data.croppingStartingMonth);
            if (croppingStartingMonthObj.length == 0) {
                setCroppingStartingMonth('');
            }
            else {
                setCroppingStartingMonth(croppingStartingMonthObj[0]);
            }
            if (response.data.croppingStartingMonth == 0) {
                setDisableViewOptions(true);
            }
            setFilterList('All');
            setMasterCropAreaList(response.data.masterCropAreaList);

            
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    }

    const handleSectionCommentChange = (e) => {
        const { name, value, checked, type } = e.target;
        setCropping({ ...cropping, sectionComment: value })
    }
    const [savingSectionComment, setSavingSectionComment] = useState('');
    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/cropping/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }
    const SaveSectionComment = async () => {
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/cropping/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
        } catch (err) {
            console.log(err);
        }
    }

    const handlePageChange = async (section, method) => {
        await SaveSectionComment();
        if (method == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (method == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
        else if (method == 'handleWizardChangedBack') {
            handleWizardChangedBack(section);
        }
    }

    const handleCroppingStartingMonthChange = async (e) => {
        setCroppingStartingMonth(e);
        let d = new Date();
        let month = d.getMonth();
        let year = d.getFullYear();
        let currentYearVal = 0;
        if (month >= e.order) {
            currentYearVal = year;
            setCurrentYear(year)
        }
        else {
            currentYearVal = year - 1;
            setCurrentYear(year-1)
        }
        if (e == null) {
            setDisableViewOptions(true);
        }
        else {
            setDisableViewOptions(false);
        }
        await changeValue(filterList, currentYearVal, cropping.cropAreaRecordTempItems, cropping.tempItemList);
    }

    const handleMonthsGrazedHarvestedChange = (e) => {
        setMonthsGrazedHarvestedSelectedValues('');
        var monthsGrazedHarvestedSelectedValues = '';
        setMonthsGrazedHarvestedListSelectedValues(e);
        e.forEach(function (element) {
            if (monthsGrazedHarvestedSelectedValues == '') {
                monthsGrazedHarvestedSelectedValues = element.value;
            }
            else {
                monthsGrazedHarvestedSelectedValues = monthsGrazedHarvestedSelectedValues + ',' + element.value;
            }
        });
        setMonthsGrazedHarvestedSelectedValues(monthsGrazedHarvestedSelectedValues);
    }

    const handleItemTypeListTogole = (isOpen, isIconUp) => {
        setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemTypeTogole = (itemTypeId, isOpen, isIconUp,) => {
        setToggleItemTypeState({ ...toggleItemTypeState, itemTypeId: itemTypeId, isOpen: isOpen, isIconUp: isIconUp })
    }

    const addMapItem = (mapItem, mapType) => {
        setIsNonContiguous(false);
        setFormContiguous({ itemId: 0, isNonContiguousItem: false, masterCropAreaItemId: 0, isSameAsMaster: false });
        let path, area = 0.0, perimeter = 0.0, coordinates = '';
        if (mapType == 'polygon') {
            path = mapItem.getPath();
            area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
        }
        setCropAreaPopup({
            ...cropAreaPopup, showCropAreaPopup: true, mapitem: mapItem, farmId: farmId, id: 0, markertype: mapType, area: area, perimeter: perimeter, coordinates: coordinates,
            Name: '', color: '', Description: '', archiveItem: true, popupName: 'Add Crop Area'
        });
        setCropAreaPopupMaptype({ ...cropAreaPopupMaptype, markertype: mapType, area: area, perimeter: perimeter, coordinates: coordinates });
    }

    function handleItemEditPopup(itemId) {
        editMapItem([], itemId, false)
    }

    const editMapItem = (mapItem, itemId, isDragged) => {
        var cropArea = cropping.itemList.filter(x => x.itemId == itemId)[0];
        let coordinates = cropArea.mapCoordinates;
        let area = 0.0, perimeter = 0.0;
        if (cropArea.mapMarkerType == "polygon") {
            const Coordinates = coordinates.split(':');
            const positions = [];
            Coordinates.filter(coor => coor != "").map((Coordinate) => {
                const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                positions.push(pos);
            })
            const tempPolygon = new window.google.maps.Polygon({
                paths: positions
            });

            let path = tempPolygon.getPath();
            area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
        }
        setCropAreaPopup({
            ...cropAreaPopup, showCropAreaPopup: true, mapitem: mapItem, farmId: farmId, id: itemId, markertype: cropArea.mapMarkerType, area: area, perimeter: perimeter, coordinates: coordinates,
            Name: cropArea.name, effectiveArea: cropArea.effectiveArea, color: cropArea.colour, Description: cropArea.description, archiveItem: cropArea.archiveItem, popupName: 'Edit Crop Area'
        });
        setCropAreaPopupMaptype({ ...cropAreaPopupMaptype, markertype: cropArea.mapMarkerType, area: area, perimeter: perimeter, coordinates: coordinates });

        const isNonContiguousItem = cropArea.isConnectedToAnotherCropAreaItem == null || cropArea.isConnectedToAnotherCropAreaItem == false || cropArea.isConnectedToAnotherCropAreaItem == undefined ? false : true
        setIsNonContiguous(isNonContiguousItem);
        setFormContiguous({ itemId: itemId, isNonContiguousItem: isNonContiguousItem, masterCropAreaItemId: cropArea.cropAreaItemId, isSameAsMaster: false });
    }

    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    const handleMapItemEdited = (itemId, type, strValue) => {
        let name = '';
        let value = '';
        if (type == "polygonBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }
        else if (type == "polylineBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }

        const itemList = cropping.itemList.map(item =>
            item.itemId === itemId
                ? { ...item, [name]: value, isEdited: true }
                : item
        )
        setCropping({ ...cropping, itemList: itemList });
    }

    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '80vw' : '50vw'}
                height={toggleSwitch == 'map' ? '80vw' : '50vw'}
                itemModel={cropping}
                mapDetails={mapDetails}
                addMapItem={addMapItem} largeEnterpriseDetails={largeEnterpriseDetails}
                editMapItem={editMapItem} handleMapItemEdited={handleMapItemEdited}
            ></MapView>
        )
    }, [cropping, mapDetails, toggleSwitch, largeEnterpriseDetails])

    function handleClearSelection() {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
        setItemPopupItemField({ ...itemPopupItemField, itemTypeId: 0 });
        window.location.reload(true);
    }

    const handleItemClick = (event, typeid, polyType) => {
        setTypeId(typeid);
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
        setItemPopupItemField({ ...itemPopupItemField, itemTypeId: typeid });
    }

    function handleCropAreaPopupClose() {
        resetValues();
    }

    function handleCropRecordPopupOpen(id) {
        setCropAreaPopup({
            ...cropAreaPopup, showCropAreaPopup: false, mapitem: [], farmId: farmId, id: 0, markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', Name: '', color: '', Description: '', archiveItem: true, popupName: 'Add Crop Area'
        });
        setCropAreaDeletePopup({ showCropAreaDeletePopup: false, id: 0 });
        var cropArea = cropping.itemList.filter(x => x.itemId == id)[0];
        setCropRecordPopup({
            ...cropRecordPopup, showCropRecordPopup: true, id: 0, Name: cropArea.name, cropAreaId: id, Year: 0, grazedHarvested: 0, CropType: '', irrigated: false, otherCropType: '', cropYield: 0,
            cultivationMethod: 0, timeOnCrop: 0, cultivationMethodRedrilling: 0, otherCropSown: '', stockTypeFed: 0, mitigationsToReduceSedimentSoilRunoff: '', cropTypeText: '', popupName: 'Add Crop Record'
        })
        setMonthSownSelectedValues('');
        setMonthSownListSelectedValues([]);
        setMonthsGrazedHarvestedSelectedValues('');
        setMonthsGrazedHarvestedListSelectedValues([]);
        setMonthBackIntoPastureSelectedValues('');
        setMonthBackIntoPastureListSelectedValues([]);
    }

    

    function handleCropRecordPopupEdit(id,cropAreaId) {
        var cropArea = cropping.itemList.filter(x => x.itemId == cropAreaId)[0];
        var cropRecord = cropArea.cropRecord.filter(x => x.id == id)[0];
        setCropRecordPopup({
            ...cropRecordPopup, showCropRecordPopup: true, id: cropRecord.id, Name: cropArea.name, cropAreaId: cropAreaId, Year: cropRecord.year, grazedHarvested: cropRecord.grazedHarvested,
            CropType: cropRecord.cropType, irrigated: cropRecord.irrigated, otherCropType: cropRecord.otherCropType, cropYield: cropRecord.cropYield,
            cultivationMethod: cropRecord.cultivationMethod, timeOnCrop: cropRecord.timeOnCrop, cultivationMethodRedrilling: cropRecord.cultivationMethodRedrilling,
            otherCropSown: cropRecord.otherCropSown, stockTypeFed: cropRecord.stockTypeFed, mitigationsToReduceSedimentSoilRunoff: cropRecord.mitigationsToReduceSedimentSoilRunoff, cropTypeText: cropRecord.cropTypeText, popupName: 'Edit Crop Record'
        })
        if (cropRecord.cropTypeValue == 'Other') {
            setColOtherCropType(true);
        }
        else {
            setColOtherCropType(false);
        }
        setMonthSownSelectedValues('');
        setMonthSownListSelectedValues([]);
        setMonthsGrazedHarvestedSelectedValues('');
        setMonthsGrazedHarvestedListSelectedValues([]);
        setMonthBackIntoPastureSelectedValues('');
        setMonthBackIntoPastureListSelectedValues([]);

        if (cropRecord.monthSownList.length > 0) {
            var monthSownSelectedValues = '';
            cropRecord.monthSownList.forEach(function (element) {
                if (monthSownSelectedValues == '') {
                    monthSownSelectedValues = element.value;
                }
                else {
                    monthSownSelectedValues = monthSownSelectedValues + ',' + element.value;
                }
            });
            setMonthSownSelectedValues(monthSownSelectedValues);
            setMonthSownListSelectedValues(cropRecord.monthSownList);
        }
        else {
            setMonthSownListSelectedValues([]);
        }

        if (cropRecord.monthsGrazedHarvestedList.length > 0) {
            var monthsGrazedHarvestedSelectedValues = '';
            cropRecord.monthsGrazedHarvestedList.forEach(function (element) {
                if (monthsGrazedHarvestedSelectedValues == '') {
                    monthsGrazedHarvestedSelectedValues = element.value;
                }
                else {
                    monthsGrazedHarvestedSelectedValues = monthsGrazedHarvestedSelectedValues + ',' + element.value;
                }
            });
            setMonthsGrazedHarvestedSelectedValues(monthsGrazedHarvestedSelectedValues);
            setMonthsGrazedHarvestedListSelectedValues(cropRecord.monthsGrazedHarvestedList);
        }
        else {
            setMonthsGrazedHarvestedListSelectedValues([]);
        }

        if (cropRecord.monthBackIntoPastureList.length > 0) {
            var monthBackIntoPastureSelectedValues = '';
            cropRecord.monthBackIntoPastureList.forEach(function (element) {
                if (monthBackIntoPastureSelectedValues == '') {
                    monthBackIntoPastureSelectedValues = element.value;
                }
                else {
                    monthBackIntoPastureSelectedValues = monthBackIntoPastureSelectedValues + ',' + element.value;
                }
            });
            setMonthBackIntoPastureSelectedValues(monthBackIntoPastureSelectedValues);
            setMonthBackIntoPastureListSelectedValues(cropRecord.monthBackIntoPastureList);
        }
        else {
            setMonthBackIntoPastureListSelectedValues([]);
        }
    }

    function handleCropRecordPopupClose() {
        setCropRecordPopup({
            ...cropRecordPopup, showCropRecordPopup: false, id: 0, Name: '', cropAreaId: 0, Year: 0, grazedHarvested: 0, CropType: '', irrigated: false, otherCropType: '', cropYield: 0,
            cultivationMethod: 0, timeOnCrop: 0, cultivationMethodRedrilling: 0, otherCropSown: '', stockTypeFed: 0, mitigationsToReduceSedimentSoilRunoff: '', cropTypeText: '', popupName: 'Add Crop Record'
        })
        setMonthSownSelectedValues('');
        setMonthSownListSelectedValues([]);
        setMonthsGrazedHarvestedSelectedValues('');
        setMonthsGrazedHarvestedListSelectedValues([]);
        setMonthBackIntoPastureSelectedValues('');
        setMonthBackIntoPastureListSelectedValues([]);
        setLoading(true);
        setCropping({
            ...cropping, outlineList: [], itemList: [], itemTypes: [], section: 'Cropping and Cultivation', sectionName: 'Cropping and Cultivation', sectionObj: {}, isWizardCompleted: false, grazedHarvested: [], stockTypeFed: [],
            cultivationMethod: [], cultivationMethodForRedrilling: [], months: [], monthMultiSelect: [], crops: [], cropAreaRecordItems: [],
        });
        OnPageload();
    }

    function handleCropAreaItemsChange(event) {
        const { name, value, checked, type } = event.target;
        if (name == 'Name') {
            if (event.target.value.length > 60) {
                return false;
            }
        }
        setCropAreaPopup({ ...cropAreaPopup, [name]: type == 'checkbox' ? checked : value });
    }

    function handleCropRecordItemsChange(event) {
        const { name, value, checked, type } = event.target;
        setCropRecordPopup({ ...cropRecordPopup, [name]: type == 'checkbox' ? checked : value });
    }

    const changeValue = async (filter, currentYearVal, cropAreaRecordTempItems, tempItemList) => {
        if (filter != 'All') {
            if (filter == 'Current') {
                var cropRecords = [...cropAreaRecordTempItems];
                cropRecords = cropRecords.filter(x => x.yearValue.split('/')[0] == currentYearVal);
                var filteredItemList = [...tempItemList];
                var cropAreas = [];
                cropRecords.forEach(item => {
                    var obj = filteredItemList.filter(x => x.itemId == item.cropAreaId);
                    if (obj.length > 0) {
                        if (cropAreas.filter(x => x.itemId == obj[0].itemId).length == 0) {
                            cropAreas.push(obj[0]);
                        }
                    }
                })
                setCropping({ ...cropping, itemList: cropAreas, cropAreaRecordItems: cropRecords });
            }
            else if (filter == 'Future') {
                var cropRecords = [...cropAreaRecordTempItems];
                cropRecords = cropRecords.filter(x => x.yearValue.split('/')[0] >= currentYearVal);
                var filteredItemList = [...tempItemList];
                var cropAreas = [];
                cropRecords.forEach(item => {
                    var obj = filteredItemList.filter(x => x.itemId == item.cropAreaId);
                    if (obj.length > 0) {
                        if (cropAreas.filter(x => x.itemId == obj[0].itemId).length == 0) {
                            cropAreas.push(obj[0]);
                        }
                    }
                })
                setCropping({ ...cropping, itemList: cropAreas, cropAreaRecordItems: cropRecords });
            }
            else if (filter == 'Historical') {
                var cropRecords = [...cropAreaRecordTempItems];
                cropRecords = cropRecords.filter(x => x.yearValue.split('/')[0] <= currentYearVal);
                var filteredItemList = [...tempItemList];
                var cropAreas = [];
                cropRecords.forEach(item => {
                    var obj = filteredItemList.filter(x => x.itemId == item.cropAreaId);
                    if (obj.length > 0) {
                        if (cropAreas.filter(x => x.itemId == obj[0].itemId).length == 0) {
                            cropAreas.push(obj[0]);
                        }
                    }
                })
                setCropping({ ...cropping, itemList: cropAreas, cropAreaRecordItems: cropRecords });
            }
        }
        else {
            var filteredItemList = [...tempItemList];
            var cropRecords = [...cropAreaRecordTempItems];
            setCropping({ ...cropping, itemList: filteredItemList, cropAreaRecordItems: cropRecords });
        }
    }

    const onChangeValue = async (event) => {
        setFilterList(event.currentTarget.getAttribute("data-value"));
        await changeValue(event.currentTarget.getAttribute("data-value"), currentYear, cropping.cropAreaRecordTempItems, cropping.tempItemList);
    }

    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
            document.getElementById('itemTypeListView').style.height = '70vh';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }

    const handleOpenWholeActionPopup = (itemId, actionId) => {
        setWholeFarmActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: cropping.outlineCenter.itemTypeId, itemName: 'Map Centre', actionId: actionId });
    };

    const [checkActionPopup, setCheckActionPopup] = useState({ showPopup: false, section: '', method: '' });
    const handleCheckActionPopupClose = () => {
        setCheckActionPopup({ showPopup: false, section: '', method: '' });
    }
    const handleCheckCalculatorDataPopupConfirm = async () => {
        await SaveSectionComment();
        if (checkActionPopup.method == 'handleWizardChanged') {
            handleWizardChanged(checkActionPopup.section);
        }
        else if (checkActionPopup.method == 'handleMoveToNextPage') {
            handleMoveToNextPage(checkActionPopup.section);
        }
        else if (checkActionPopup.method == 'handleWizardChangedBack') {
            handleWizardChangedBack(checkActionPopup.section);
        }
    }
    const checkAction = async (section, method) => {
        await SaveSectionComment();
        if (!isThisPageCompleted && actionsCount == 0) {
            setCheckActionPopup({ showPopup: true, section: section, method: method });
        }
        else {
            if (method == 'handleWizardChanged') {
                handleWizardChanged(section);
            }
            else if (method == 'handleMoveToNextPage') {
                handleMoveToNextPage(section);
            }
            else if (method == 'handleWizardChangedBack') {
                handleWizardChangedBack(section);
            }
        }
    }

    const CustomToastWithLink = () => (
        <div>
            <p>You can use this section to view cropping history and/or add a new crop record.</p>
        </div>
    );
    const customId = "custom-id-yes";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    const [toggleItemState, setToggleItemState] = useState({ itemId: 0, isOpen: false, isIconUp: false });
    const [toggleChildItemState, setToggleChildItemState] = useState({ itemId: 0, isOpen: false, isIconUp: false });
    const handleItemTogole = (itemId, isOpen, isIconUp) => {
        setToggleItemState({ ...toggleItemState, itemId: itemId, isOpen: isOpen, isIconUp: isIconUp })
    }
    const handleChildItemToggle = (itemId, isOpen, isIconUp) => {
        setToggleChildItemState({ ...toggleChildItemState, itemId: itemId, isOpen: isOpen, isIconUp: isIconUp })
    }
    const [hideChildren, setHideChildren] = useState({ cropAreaItemId: 0, childCropAreaDisplay: 0, ishideChildren: true });
    const handleHideChildrenCheck = (event, cropAreaItemId) => {
        const { name, value, checked, type } = event.target;
        let selectedCropAreaItemId = 0;
        let ishideChildren = true;
        if (name == 'childCropAreaDisplay' && value == 1) {
            selectedCropAreaItemId = cropAreaItemId;
            ishideChildren = false;
        }
        setHideChildren({ ...hideChildren, cropAreaItemId: cropAreaItemId, ishideChildren: ishideChildren, childCropAreaDisplay: value });
    }

    const nonMapView = useMemo(() => {
        return (
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <Row>
                                <Col>
                                    <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                        
                                        { /* Header */}
                                        <Row>
                                            <Col>
                                                <>
                                                    <Row>
                                                        <Col>
                                                            <Row>
                                                                <Col>
                                                                    <h4>Cropping and Cultivation </h4>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Label className="info-text">Click an icon and place it on the map to mark and manage the crop area</Label>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </>
                                                <hr />
                                                <ItemTypeListView Section={cropping.section}
                                                    itemTypesList={cropping.itemTypes}
                                                    toggleItemTypeListState={toggleItemTypeListState}
                                                    handleClearSelection={handleClearSelection}
                                                    handleItemClick={handleItemClick}
                                                    handleItemTypeListTogole={handleItemTypeListTogole}
                                                >
                                                </ItemTypeListView>
                                            </Col>
                                        </Row>

                                        {cropping.sectionObj.isWholeFarmActionRequired &&
                                            <>
                                            <br />
                                            <WholeFarmActionView outlineCenter={cropping.outlineCenter} handleOpenWholeActionPopup={handleOpenWholeActionPopup} open={false} showArrow={true}></WholeFarmActionView>
                                                <br />
                                            </>
                                        }
                                        {show_HistoricalActions && 
                                            <HistoricalActions sectionId={cropping.sectionObj.id} open={false} showArrow={true}></HistoricalActions>    
                                        }

                                        <Row className="my-3">
                                            <Col sm="12" key={uuid()}>
                                                <h6 className="text-uppercase">Crop Areas and History&nbsp;&nbsp;&nbsp;
                                                    <img className="featureIcon" src="/images/info_button_dk.png" data-tooltip-id="my-tooltip-30" onClick={(e) => e.stopPropagation()} /></h6>
                                                <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                                    id="my-tooltip-30"
                                                    place="top"
                                                    variant="info"
                                                    render={({ content, activeAnchor }) => (
                                                        <>
                                                            <Row>
                                                                <Col>
                                                                    <p style={{ fontWeight: "lighter" }}>
                                                                        For more information on Cropping <a href="https://freshwaterfarmplan.co.nz/support-category/cropping/" target="_blank" rel="noreferrer">Click Here</a>
                                                                    </p>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    )}
                                                />
                                                <Row>
                                                    <Col sm="9">
                                                        <Row>
                                                            <Col sm="2">View</Col>
                                                            <Col sm="2"><Radio value="All" selected={filterList} onClick={onChangeValue}> <strong>All</strong></Radio></Col>
                                                            <Col sm="2"><Radio value="Current" id="Current" disabled={ disableViewOptions} name="Current" selected={filterList} onClick={onChangeValue}> <strong>Current Only (this year)</strong></Radio></Col>
                                                            <Col sm="2"><Radio value="Future" id="Future" disabled={disableViewOptions} name="Future" selected={filterList} onClick={onChangeValue}> <strong>Future Planned (including current year)</strong></Radio></Col>
                                                            <Col sm="2"><Radio value="Historical" id="Historical" disabled={disableViewOptions} name="Historical" selected={filterList} onClick={onChangeValue}> <strong>Historical Only (include current year)</strong></Radio></Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm="3">
                                                        <FormGroup>
                                                            <Label style={{ fontSize: "11px" }}><b>Please indicate what is the 'starting' month for the annual cropping cycle</b></Label>
                                                            <Select id="croppingStartingMonth" name="croppingStartingMonth" className="dropdown" placeholder="Select Option" closeMenuOnSelect={true}
                                                                value={croppingStartingMonth} options={croppingStartingMonthList} hideSelectedOptions={false}
                                                                onChange={handleCroppingStartingMonthChange} isClearable components={{
                                                                    Option
                                                                }} />
                                                            {(roleName == 'Admin' || isAddEditItem == 'true') &&
                                                                <>
                                                            {croppingStartingMonthSaving ?
                                                                <>
                                                                    <Button style={{ marginTop: "10px" }} onClick={handleCroppingStartingMonthSubmit} color="success" disabled>
                                                                        <Row>
                                                                            <Col sm="12">
                                                                                <span>
                                                                                    {' '}Saving
                                                                                </span>
                                                                            </Col>
                                                                            <Col sm="12">
                                                                                <Spinner size="sm">
                                                                                    Saving...
                                                                                </Spinner>
                                                                            </Col>
                                                                        </Row></Button>{' '}
                                                                </>
                                                                :
                                                                <>
                                                                    <Button disabled={disableViewOptions} style={{ marginTop: "10px" }} onClick={handleCroppingStartingMonthSubmit} color="primary">
                                                                        Save
                                                                    </Button>{' '}
                                                                </>
                                                                }
                                                                </>
                                                            }
                                                         </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {cropping.itemList != undefined && cropping.itemList != null && cropping.itemList.map((item, idx) => (
                                            <CropAreaItemView cropping={cropping} handleHideChildrenCheck={handleHideChildrenCheck} hideChildren={hideChildren} key={uuid()} handleCropRecordPopupOpen={handleCropRecordPopupOpen} handleItemEditPopup={handleItemEditPopup} handleCropRecordPopupEdit={handleCropRecordPopupEdit}
                                                toggleItemState={toggleItemState} handleItemTogole={handleItemTogole} toggleChildItemState={toggleChildItemState} handleChildItemToggle={handleChildItemToggle}
                                                cropAreaItem={item} cropAreaRecordItems={cropping.cropAreaRecordItems.filter(x => x.cropAreaId == item.itemId)} handleItemHighlight={handleItemHighlight}></CropAreaItemView>
                                        ))}

                                    </div>
                                </Col>
                            </Row>
                            {/*Document Upload*/}
                            {
                                cropping.sectionObj.isDocumentUploadReq && <Documents refid={cropping.sectionObj.id} uploadType="Section" open={false} showArrow={true}></Documents>
                            }
                            {
                                cropping.sectionObj.isFarmAPTActionsReq && <ActionsToConsider sectionId={cropping.sectionObj.id} />
                            }
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }, [cropping, toggleItemTypeListState, groupByCropArea, croppingStartingMonth, croppingStartingMonthSaving, handleHideChildrenCheck, hideChildren,
        toggleItemState, handleItemTogole, toggleChildItemState, handleChildItemToggle
    ])

    const itemTypeListView = useMemo(() => {
        return (
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <Row>
                                <Col>
                                    <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                        <Row>
                                            <Col>
                                                <h4>Cropping and Cultivation </h4>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Label className="info-text">Click an icon and place it on the map to mark and manage the crop area</Label>
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row>
                                            <Col>
                                                <ItemTypeListViewForMap Section="Cropping"
                                                    itemTypesList={cropping.itemTypes}
                                                    toggleItemTypeListState={toggleItemTypeListState}
                                                    handleClearSelection={handleClearSelection}
                                                    handleItemClick={handleItemClick}
                                                    handleItemTypeListTogole={handleItemTypeListTogole}>
                                                </ItemTypeListViewForMap>
                                            </Col>
                                        </Row>

                                        <Row className="my-3">
                                            <Col sm="12" key={uuid()}>
                                                <h6 className="text-uppercase">Crop Areas and History&nbsp;&nbsp;&nbsp;
                                                    <img className="featureIcon" src="/images/info_button_dk.png" onClick={(e) => showToastMessage(e)} /></h6>
                                                <Row>
                                                    <Col sm="12">
                                                        <Row>
                                                            <Col sm="6">View</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="6"><Radio value="All" selected={filterList} onClick={onChangeValue}> <strong>All</strong></Radio></Col>
                                                            <Col sm="6"><Radio value="Current" id="Current" disabled={disableViewOptions} name="Current" selected={filterList} onClick={onChangeValue}> <strong>Current Only (this year)</strong></Radio></Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm="12">
                                                        <Row>
                                                            <Col sm="6"><Radio value="Future" id="Future" disabled={disableViewOptions} name="Future" selected={filterList} onClick={onChangeValue}> <strong>Future Planned (including current year)</strong></Radio></Col>
                                                            <Col sm="6"><Radio value="Historical" id="Historical" disabled={disableViewOptions} name="Historical" selected={filterList} onClick={onChangeValue}> <strong>Historical Only (include current year)</strong></Radio></Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm="12">
                                                        <FormGroup>
                                                            <Label style={{ fontSize: "11px" }}><b>Please indicate what is the 'starting' month for the annual cropping cycle</b></Label>
                                                            <Select id="croppingStartingMonth" name="croppingStartingMonth" className="dropdown" placeholder="Select Option" closeMenuOnSelect={true}
                                                                value={croppingStartingMonth} options={croppingStartingMonthList} hideSelectedOptions={false}
                                                                onChange={handleCroppingStartingMonthChange} isClearable components={{
                                                                    Option
                                                                }} />
                                                            {croppingStartingMonthSaving ?
                                                                <>
                                                                    <Button style={{ marginTop: "10px" }} onClick={handleCroppingStartingMonthSubmit} color="success" disabled>
                                                                        <Row>
                                                                            <Col sm="6">
                                                                                <span>
                                                                                    {' '}Saving
                                                                                </span>
                                                                            </Col>
                                                                            <Col sm="6">
                                                                                <Spinner size="sm">
                                                                                    Saving...
                                                                                </Spinner>
                                                                            </Col>
                                                                        </Row></Button>{' '}
                                                                </>
                                                                :
                                                                <>
                                                                    <Button disabled={disableViewOptions} style={{ marginTop: "10px" }} onClick={handleCroppingStartingMonthSubmit} color="primary">
                                                                        Save
                                                                    </Button>{' '}
                                                                </>
                                                            }
                                                            {/*<Button className="float-end btn-next-page" disabled={disableViewOptions} style={{ marginTop: "10px" }} onClick={handleCroppingStartingMonthSubmit}>Save</Button>*/}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>

                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }, [cropping, toggleItemTypeListState, groupByCropArea, croppingStartingMonth])
    function handleCropAreaDeletePopup(id) {
        setCropAreaDeletePopup({ showCropAreaDeletePopup: true, id: id });
    }
    function handleCropRecordDeletePopup(id) {
        setCropRecordDeletePopup({ showCropRecordDeletePopup: true, id: id });
    }
    function handleCloseCropAreaDeletePopup() {
        setCropAreaDeletePopup({ showCropAreaDeletePopup: false, id: 0 });
    }
    function handleCloseCropRecordDeletePopup() {
        setCropAreaDeletePopup({ showCropAreaDeletePopup: false, id: 0 });
    }
    
    const handleCropAreaSubmit = async (event) => {
        setCropAreaSaving(true);
        
        setFormErrors({});
        const errors = {};
        if (formContiguous.isNonContiguousItem) {
            if (formContiguous.masterCropAreaItemId == undefined || formContiguous.masterCropAreaItemId == null || formContiguous.masterCropAreaItemId == 0) {
                errors.masterCropAreaItemId = "This is mandatory!";
            }
        }
        setFormErrors(errors);
        let form = {
            Id: cropAreaPopup.id,
            MapMarkerType: cropAreaPopup.markertype,
            FarmId: cropAreaPopup.farmId,
            Name: cropAreaPopup.Name,
            Description: cropAreaPopup.Description,
            Colour: cropAreaPopup.color,
            Size: cropAreaPopup.area,
            Length: cropAreaPopup.perimeter,
            MapCoordinates: cropAreaPopup.coordinates,
            UserId: userId,
            IsConnectedToAnotherCropAreaItem: formContiguous.isNonContiguousItem,
            CropAreaItemId: formContiguous.masterCropAreaItemId, EffectiveArea: cropAreaPopup.effectiveArea
        }
        if (!Validate(form) && Object.keys(errors).length == 0) {
            try {
                const response = await apiPost(
                    '/api/cropping/SaveCropArea/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
                if (response.data != null) {
                    const response = await apiGet(
                        '/api/cropping/GetCropping/', {
                        params: {
                            farmId: farmId
                        }
                    }
                    );
                    setMasterCropAreaList(response.data.masterCropAreaList);
                    response.data.cropAreaItems.forEach((item) => {
                        item.nonContiguousItems = [];
                        response.data.cropAreaItems.map(nc => {
                            if (nc.cropAreaItemId === item.itemId) {
                                item.nonContiguousItems.push(nc);
                            }
                        })

                    })
                    setTempItemList(response.data.cropAreaItems);
                    setCropping({
                        ...cropping, tempItemList: response.data.cropAreaItems,
                        cropAreaRecordTempItems: response.data.cropAreaRecordItems,
                    });
                    await changeValue(filterList, currentYear, response.data.cropAreaRecordItems, response.data.cropAreaItems);
                    toast.success("Crop area details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                    setCropAreaSaving(false);
                    resetValues();
                }
            } catch (error) {
                setCropAreaSaving(false);
                console.error('Error:', error);
            }
        }
        else {
            setCropAreaSaving(false);
        }
    }

    function resetValues() {
        setCropAreaPopup({
            ...cropAreaPopup, showCropAreaPopup: false, mapitem: [], farmId: farmId, id: 0, markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', Name: '', color: '', Description: '', archiveItem: true, popupName: 'Add Crop Area'
        });
        setCropRecordPopup({
            ...cropRecordPopup, showCropRecordPopup: false, id: 0, Name: '', cropAreaId: 0, Year: 0, grazedHarvested: 0, CropType: 0, irrigated: false, otherCropType: '', cropYield: 0,
            cultivationMethod: 0, timeOnCrop: 0, cultivationMethodRedrilling: 0, otherCropSown: '', stockTypeFed: 0, popupName: 'Add Crop Record'
        })
        setMonthSownSelectedValues('');
        setMonthSownListSelectedValues([]);
        setMonthsGrazedHarvestedSelectedValues('');
        setMonthsGrazedHarvestedListSelectedValues([]);
        setMonthBackIntoPastureSelectedValues('');
        setMonthBackIntoPastureListSelectedValues([]);
        setCropAreaDeletePopup({ showCropAreaDeletePopup: false, id: 0 });
        setCropRecordDeletePopup({ showCropRecordDeletePopup: false, id: 0 });
        setMapDetails({ ...mapDetails, isClear: true, polyType: '' });
        setIsNonContiguous(false);
        setFormContiguous({ itemId: 0, isNonContiguousItem: false, masterCropAreaItemId: 0, isSameAsMaster: false });
    }

    const hanldeCropTypeChange = async (e) => {
        setCropRecordPopup({ ...cropRecordPopup, cropTypeText: e.target.value });
        //var crop = cropping.crops.filter(x => x.id == e.target.value)[0];
        //if (crop.name == 'Other') {
        //    setColOtherCropType(true);
        //}
        //else {
        //    setColOtherCropType(false);
        //}
    }

    const handleMonthSownChange = (e) => {
        setMonthSownSelectedValues('');
        var monthSownSelectedValues = '';
        setMonthSownListSelectedValues(e);
        e.forEach(function (element) {
            if (monthSownSelectedValues == '') {
                monthSownSelectedValues = element.value;
            }
            else {
                monthSownSelectedValues = monthSownSelectedValues + ',' + element.value;
            }
        });
        setMonthSownSelectedValues(monthSownSelectedValues);
    }

    

    const handleMonthBackIntoPastureChange = (e) => {
        setMonthBackIntoPastureSelectedValues('');
        var monthBackIntoPastureSelectedValues = '';
        setMonthBackIntoPastureListSelectedValues(e);
        e.forEach(function (element) {
            if (monthBackIntoPastureSelectedValues == '') {
                monthBackIntoPastureSelectedValues = element.value;
            }
            else {
                monthBackIntoPastureSelectedValues = monthBackIntoPastureSelectedValues + ',' + element.value;
            }
        });
        setMonthBackIntoPastureSelectedValues(monthBackIntoPastureSelectedValues);
    }

    const handleCropRecordSubmit = async (event) => {
        setCropRecordSaving(true);
        let form = {
            Id: cropRecordPopup.id,
            FarmId: farmId,
            CropAreaId: cropRecordPopup.cropAreaId,
            Year: cropRecordPopup.Year,
            GrazedHarvested: cropRecordPopup.grazedHarvested,
            CropTypeText: cropRecordPopup.cropTypeText,
            Irrigated: cropRecordPopup.irrigated,
            OtherCropType: cropRecordPopup.otherCropType,
            CropYield: cropRecordPopup.cropYield,
            StockTypeFed: cropRecordPopup.stockTypeFed,
            CultivationMethod: cropRecordPopup.cultivationMethod,
            TimeOnCrop: cropRecordPopup.timeOnCrop,
            CultivationMethodRedrilling: cropRecordPopup.cultivationMethodRedrilling,
            OtherCropSown: cropRecordPopup.otherCropSown,
            MonthSown: monthSownSelectedValues.toString(),
            MonthsGrazedHarvested: monthsGrazedHarvestedSelectedValues.toString(),
            MonthBackIntoPasture: monthBackIntoPastureSelectedValues.toString(),
            UserId: userId,
            MitigationsToReduceSedimentSoilRunoff: cropRecordPopup.mitigationsToReduceSedimentSoilRunoff
        }
        if (!Validate(form)) {
            try {
                const response = await apiPost(
                    '/api/cropping/SaveCropRecord/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
                if (response.data != null) {
                    const response = await apiGet(
                        '/api/cropping/GetCropping/', {
                        params: {
                            farmId: farmId
                        }
                    }
                    );
                    setMasterCropAreaList(response.data.masterCropAreaList);
                    response.data.cropAreaItems.forEach((item) => {
                        item.nonContiguousItems = [];
                        response.data.cropAreaItems.map(nc => {
                            if (nc.cropAreaItemId === item.itemId) {
                                item.nonContiguousItems.push(nc);
                            }
                        })

                    })
                    setCropping({
                        ...cropping, tempItemList: response.data.cropAreaItems, cropAreaRecordTempItems: response.data.cropAreaRecordItems,
                    });
                    await changeValue(filterList, currentYear, response.data.cropAreaRecordItems, response.data.cropAreaItems);
                    setCropRecordSaving(false);
                    toast.success("Crop record details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                    resetValues();
                }
            } catch (error) {
                setCropRecordSaving(false);
                console.error('Error:', error);
            }
        }
        else {
            setCropRecordSaving(false);
        }
    }

    const deleteItem = async (event) => {
        setItemDeleteSaving(true);
        const itemid = cropAreaDeletePopup.id;
        try {
            const response = await apiGet(
                '/api/cropping/DeleteItem/', {
                    params: {
                        itemId: itemid, userId: userId, farmId: farmId
                }
            });
            if (response.data != null) {
                setItemDeleteSaving(false);
                setCropping({
                    ...cropping, tempItemList: response.data.content.cropAreaItems, cropAreaRecordTempItems: response.data.content.cropAreaRecordItems,
                });
                await changeValue(filterList, currentYear, response.data.content.cropAreaRecordItems, response.data.content.cropAreaItems);
                setCropAreaDeletePopup({ ...cropAreaDeletePopup, showCropAreaDeletePopup: false });
                setCropAreaPopup({ ...cropAreaPopup, showCropAreaPopup: false });
                toast.success("Crop area details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                resetValues();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }
    const deleteCropRecordItem = async (event) => {
        setItemDeleteCropRecordSaving(true);
        const itemid = cropRecordDeletePopup.id;
        try {
            const response = await apiGet(
                '/api/cropping/DeleteCropRecordItem/', {
                params: {
                    itemId: itemid, userId: userId, farmId: farmId
                }
            });
            if (response.data != null) {
                setItemDeleteCropRecordSaving(false);
                setCropping({
                    ...cropping, tempItemList: response.data.content.cropAreaItems, cropAreaRecordTempItems: response.data.content.cropAreaRecordItems,
                });
                await changeValue(filterList, currentYear, response.data.content.cropAreaRecordItems, response.data.content.cropAreaItems);
                toast.success("Crop record details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setCropRecordDeletePopup({ ...cropRecordDeletePopup, showCropRecordDeletePopup: false });
                setCropRecordPopup({ ...cropRecordPopup, showCropRecordPopup: false });
                resetValues();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }
    const handleRiskSummaryClose = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: false })
        window.location.reload(true);
    }
    const handleRiskSummaryOpen = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: true })
    }
    const handleEditItemClick = (e) => {
        if (e.target.checked) {
            toast.error("ALERT: when editing a shape remember to click inside the shape when finished, or when editing a line double click on the line, to save any changes.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        setMapDetails({ ...mapDetails, isFarmCenterEditable: !mapDetails.itemsEditable, isFarmOutlineEditable: !mapDetails.itemsEditable, itemsEditable: !mapDetails.itemsEditable })
    }

    const [formContiguous, setFormContiguous] = useState({ itemId: 0, isNonContiguousItem: false, masterCropAreaItemId: 0, isSameAsMaster: false });
    const [formErrors, setFormErrors] = useState({});
    const [isNonContiguous, setIsNonContiguous] = useState(false);
    const handleFormFieldChange = (e) => {
        const { name, value, checked, type } = e.target;
        const masterCropAreaItemId = parseInt(formContiguous.masterCropAreaItemId);

        if (name == "isNonContiguousItem" && checked == true) {
            setFormContiguous({ ...formContiguous, [name]: type == 'checkbox' ? checked : value });
            setIsNonContiguous(true);
        }
        else if (name == "isNonContiguousItem" && checked == false) {
            setFormContiguous({ ...formContiguous, [name]: type == 'checkbox' ? checked : value, masterCropAreaItemId: 0 });
            setIsNonContiguous(false);
        }
        else {
            setFormContiguous({ ...formContiguous, [name]: type == 'checkbox' ? checked : value });
        }
    }

    

    return (
        <div>
            <Modal isOpen={checkActionPopup.showPopup}>
                <ModalHeader toggle={handleCheckActionPopupClose} >Confirm</ModalHeader>
                <ModalBody>
                    You have not created any actions on this page. Are you sure you wish to continue?
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleCheckCalculatorDataPopupConfirm} color="primary">
                        Yes
                    </Button>{' '}
                    <Button color="danger" onClick={handleCheckActionPopupClose}>No</Button>
                </ModalFooter>
            </Modal>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{cropping.sectionName}</h3></Col>
                <Col>
                {
                     !loading &&
                        <>
                            {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                <>
                                <Button className="float-end btn-next-page" onClick={(section) => checkAction(cropping.section, 'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                                </>
                            }
                            {roleName != 'Admin' && saveRightsForNonItemFieldsAndTables == 'false' && isNextButtonVisible &&
                                <>
                                <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(cropping.section,'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                                </>
                            }
                            <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(cropping.section,'handleWizardChangedBack')}>Back <FaChevronLeft /> </Button>
                    </>
                    
                }
                </Col>
            </Row>
            <br/>
            {
                loading ? <SpinnerContainer /> :
                    <div>
                        <Row style={{ marginTop: '10px' }}>
                            <Col id='mapView'>
                                <Row className="map-layer">
                                    <Col>
                                        <Row>
                                            <Col sm="3"> {toggleSwitch == 'map & details' &&
                                                <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                                    <img src="/images/button-details_expand.png" className="card_icon" ></img>
                                                </Button>
                                            }
                                                {toggleSwitch == 'map' &&
                                                    <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                        <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                                    </Button>
                                                }
                                            </Col>
                                            <Col sm="1"></Col>
                                            <Col sm="8">
                                                <div className="map-item-edit-div">
                                                    <Label className="map-checkbox-label">Show LU layer</Label>
                                                    <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={largeEnterpriseDetails.isSmallEnterpriseShow} onChange={(e) => setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isSmallEnterpriseShow: !largeEnterpriseDetails.isSmallEnterpriseShow })} name="isSmallEnterpriseShow" id="isSmallEnterpriseShow" />&nbsp;&nbsp;
                                                    <Label className="map-checkbox-label">Edit Item</Label>
                                                    <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.itemsEditable} onChange={(e) => handleEditItemClick(e)} name="isItemEdit" id="isItemEdit" />&nbsp;&nbsp;
                                                    <Label className="map-checkbox-label">Show Label</Label>
                                                    <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.showLabel} onChange={(e) => setMapDetails({ ...mapDetails, showLabel: !mapDetails.showLabel })} name="showLabel" id="showLabel" />&nbsp;&nbsp;
                                                </div>
                                            </Col>
                                        </Row>
                                        {mapView}
                                    </Col>
                                </Row>
                            </Col>
                            <Col id="itemTypeListView" style={{ display: toggleSwitch == 'map' ? 'block' : 'none', height: "70vh", overflowY: "scroll", width: "20vw" }}>
                                <br />
                                {itemTypeListView}
                                <br />
                            </Col>
                            <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', marginTop: "-25px" }}>
                                <Row>
                                    <Col style={{ borderBottom: "1px solid #0d535d" }}>
                                        {toggleSwitch == 'map & details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                                <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                        {toggleSwitch == 'details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                                <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                        {
                                            !loading && <Button style={{ marginLeft: "0.5vw" }} onClick={() => handleRiskSummaryOpen()} className="btn btn-risk-summary">Risk and Actions summary</Button>
                                        }
                                    </Col>
                                </Row>
                                {show_SectionComment && 
                                    <>
                                    <Row style={{ marginTop: "0.5vh" }}>
                                        <Col sm="12">
                                            <FormGroup>
                                                <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "16px" }}><b>Section Comment</b> <span className="text-lowercase">(add any information around the features, actions, or risks, that have been considered on this page)</span></Label>
                                                <Editor handlePastedText={() => false}
                                                    defaultEditorState={editorState}
                                                    onEditorStateChange={setEditorState}
                                                    wrapperClassName="wrapper-class"
                                                    editorClassName="editor-class"
                                                    toolbarClassName="toolbar-class"
                                                    toolbar={
                                                        {
                                                            options: ['inline'], inline: {
                                                                inDropdown: false,
                                                                options: ['bold', 'italic', 'underline'],
                                                            }
                                                        }
                                                    }
                                                />
                                            </FormGroup>

                                        </Col>
                                        <Col sm="12">
                                            {savingSectionComment ?
                                                <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                                    <Row>
                                                        <Col sm="8">
                                                            <span>
                                                                {' '}Saving
                                                            </span>
                                                        </Col>
                                                        <Col sm="4">
                                                            <Spinner size="sm">
                                                                Saving...
                                                            </Spinner>
                                                        </Col>
                                                    </Row>
                                                </Button>
                                                :
                                                <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                                    Save
                                                </Button>
                                            }
                                        </Col>
                                    </Row>
                                    <br />
                                    </>    
                                }
                                
                                
                                <Row>
                                    <Col>
                                        {nonMapView}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        
                    </div>
                    
            }

            <Modal isOpen={cropAreaDeletePopup.showCropAreaDeletePopup}>
                <ModalHeader toggle={handleCloseCropAreaDeletePopup} >Delete Crop Area</ModalHeader>
                <ModalBody>
                    Do you want to delete the crop area ?
                </ModalBody>
                <ModalFooter>
                    {itemDeletesaving ?
                        <>
                            <Button onClick={deleteItem} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Saving
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Saving...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={deleteItem} color="primary">
                                Yes
                            </Button>{' '}
                        </>
                    }
                    <Button color="danger" onClick={handleCloseCropAreaDeletePopup}>No</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={cropRecordDeletePopup.showCropRecordDeletePopup}>
                <ModalHeader toggle={handleCloseCropRecordDeletePopup} >Delete Crop Record</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete this crop record ?
                </ModalBody>
                <ModalFooter>
                    {itemDeleteCropRecordsaving ?
                        <>
                            <Button onClick={deleteCropRecordItem} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Saving
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Saving...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={deleteCropRecordItem} color="primary">
                                Yes
                            </Button>{' '}
                        </>
                    }
                    <Button color="danger" onClick={handleCloseCropRecordDeletePopup}>No</Button>
                </ModalFooter>
            </Modal>

            <Modal size="lg" isOpen={cropAreaPopup.showCropAreaPopup} backdrop={false} className="cropAreaPopup">
                <Form>
                    <ModalHeader toggle={handleCropAreaPopupClose} >{cropAreaPopup.popupName}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Name</Label>
                                    <Input type="text" className="validate" name="Name" id="Name" value={cropAreaPopup.Name} onChange={handleCropAreaItemsChange} required />
                                </FormGroup>
                            </Col>
                            <Col sm="2">
                                <FormGroup>
                                    <Label>Colour</Label>
                                    <Input type="color" name="color" id="color" value={cropAreaPopup.color} onChange={handleCropAreaItemsChange} />
                                </FormGroup>
                            </Col>
                            <MapType itemPopupMaptype={cropAreaPopupMaptype}></MapType>
                        </Row>
                        <Row>
                            <Col sm="9">
                                <FormGroup>
                                    <Label>Description</Label>
                                    <Input type="textarea" className="validate" name="Description" id="Description" value={cropAreaPopup.Description} onChange={handleCropAreaItemsChange} required />
                                </FormGroup>
                            </Col>
                            <Col sm="3">
                                <FormGroup>
                                    <Label>Effective Area (HA)</Label>
                                    <Input type="number" name="effectiveArea" step="0.1" min='0' autoComplete="new-password" id="effectiveArea" value={cropAreaPopup.effectiveArea} onChange={handleCropAreaItemsChange} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {
                                    masterCropAreaList.length > 0 &&
                                    <>
                                        <Row>
                                            <Col sm="12">
                                                <Label for="inherentRisks">Join Crop Area</Label>
                                            </Col>
                                            <Col sm="12">
                                                <Label className="info-text" style={{ fontSize: "14px" }}>Sometimes separate items be part of the same crop area. Select to join this crop area to another item.</Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="6">
                                                <Row>
                                                    <Col sm="12">
                                                        <FormGroup check>
                                                            <Label
                                                                check
                                                                for="isNonContiguousItem"
                                                            >
                                                                Join Crop Area
                                                            </Label>
                                                            <Input
                                                                defaultChecked={formContiguous.isNonContiguousItem}
                                                                id="isNonContiguousItem"
                                                                name="isNonContiguousItem"
                                                                type="checkbox"
                                                                value={formContiguous.isNonContiguousItem}
                                                                onChange={handleFormFieldChange}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            {
                                                isNonContiguous &&
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Input bsSize="sm"
                                                                type="select"
                                                                value={formContiguous.masterCropAreaItemId}
                                                            onChange={handleFormFieldChange}
                                                                name="masterCropAreaItemId"
                                                                id="masterCropAreaItemId"
                                                        >
                                                                <option value={0} >Select crop area to join with</option>
                                                                {masterCropAreaList.filter(x => x.id != cropAreaPopup.id).map(c =>
                                                                <option key={c.id} value={c.id}>{c.value}</option>
                                                            )}
                                                        </Input>
                                                    </FormGroup>
                                                        {formErrors.masterCropAreaItemId != undefined &&
                                                            <p className="errorMessage">{formErrors.masterCropAreaItemId}</p>
                                                    }
                                                </Col>
                                            }
                                        </Row>
                                    </>
                                }
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            {cropAreaPopup.id !== 0 && <Button color="warning" onClick={(id) => handleCropRecordPopupOpen(cropAreaPopup.id)} size="sm">Add Crop Record</Button>}{' '}
                            {cropAreaPopup.id !== 0 && cropAreaPopup.archiveItem && <Button color="danger" onClick={(id) => handleCropAreaDeletePopup(cropAreaPopup.id)} size="sm">Delete</Button>}{' '}
                            {(roleName == 'Admin' || isAddEditItem == 'true') &&
                                <>
                                    {cropAreaSaving ?
                                        <>
                                            <Button onClick={handleCropAreaSubmit} id="saveCropArea" color="success" disabled size="sm">
                                                <Row>
                                                    <Col sm="6">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="6">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row></Button>{' '}
                                        </>
                                        :
                                        <>
                                            <Button onClick={handleCropAreaSubmit} id="saveCropArea" color="success" size="sm">
                                                Save
                                            </Button>{' '}
                                        </>
                                    }
                                </>
                            }
                            <Button color="primary" onClick={handleCropAreaPopupClose} size="sm">Cancel</Button>
                        </div>
                    </ModalFooter>
                </Form>
            </Modal>

            <Modal size="lg" isOpen={cropRecordPopup.showCropRecordPopup} backdrop={false} className="cropRecordPopup">
                <Form>
                    <ModalHeader toggle={handleCropRecordPopupClose} >{cropRecordPopup.popupName}</ModalHeader>
                    <ModalBody>
                        <Row style={{ display: "none" }}>
                            <Col>
                                <FormGroup>
                                    <Label>Name</Label>
                                    <Input type="text" disabled name="Name" id="Name" value={cropRecordPopup.Name} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12">
                                <FormGroup>
                                    <Label>Crop</Label>
                                    <Input type="text" name="cropTypeText" id="cropTypeText" value={cropRecordPopup.cropTypeText} onChange={hanldeCropTypeChange} />
                                </FormGroup>
                            </Col>
                            <Col sm="6" style={{ display: "none" }}>
                                <FormGroup>
                                    <br />
                                    <Input type="checkbox" checked={cropRecordPopup.irrigated} onChange={(e) => setCropRecordPopup({ ...cropRecordPopup, irrigated: !cropRecordPopup.irrigated })} name="irrigated" id="irrigated" />
                                    <Label style={{ marginLeft: `15px` }} for="irrigated">Freshwater Irrigation</Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Year (Note: start month (MM))</Label>
                                    {cropping.year == undefined && <p><em>Loading...</em></p>}
                                    {cropping.year != undefined && cropping.year != null &&
                                        <Input type="select" className="validate" value={cropRecordPopup.Year} onChange={e => setCropRecordPopup({ ...cropRecordPopup, Year: e.target.value })} name="Year" id="Year">
                                            {cropping.year.map(items =>
                                                <option key={uuid()} value={items.id}>{items.name}</option>
                                            )}
                                        </Input>
                                    }
                                </FormGroup>
                            </Col>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Crop Yield (Tonnes DM/HA)</Label>
                                    <Input type="text" name="cropYield" id="cropYield" value={cropRecordPopup.cropYield} onChange={handleCropRecordItemsChange} onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }} />
                                </FormGroup>
                            </Col>
                            <Col sm="6" style={{ display: "none" }}>
                                <FormGroup>
                                    <Label>Grazed / Harvested</Label>
                                    {cropping.grazedHarvested == undefined && <p><em>Loading...</em></p>}
                                    {cropping.grazedHarvested != undefined && cropping.grazedHarvested != null &&
                                        <Input type="select" value={cropRecordPopup.grazedHarvested} onChange={e => setCropRecordPopup({ ...cropRecordPopup, grazedHarvested: e.target.value })} name="grazedHarvested" id="grazedHarvested">
                                            {cropping.grazedHarvested.map(items =>
                                                <option key={uuid()} value={items.id}>{items.name}</option>
                                            )}
                                        </Input>
                                    }
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>

                            <Col sm="6">
                                <FormGroup>
                                    <Label>Month Sown</Label>
                                    <Select className="dropdown" placeholder="Select Option" value={monthSownListSelectedValues} options={monthSownList} onChange={handleMonthSownChange} isMulti isClearable />
                                </FormGroup>
                            </Col>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Months Harvested</Label>
                                    <Select className="dropdown" placeholder="Select Option" value={monthsGrazedHarvestedListSelectedValues} options={monthsGrazedHarvestedList} onChange={handleMonthsGrazedHarvestedChange} isMulti isClearable />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Cultivation Method</Label>
                                    {cropping.cultivationMethod == undefined && <p><em>Loading...</em></p>}
                                    {cropping.cultivationMethod != undefined && cropping.cultivationMethod != null &&
                                        <Input type="select" value={cropRecordPopup.cultivationMethod} onChange={e => setCropRecordPopup({ ...cropRecordPopup, cultivationMethod: e.target.value })} name="cultivationMethod" id="cultivationMethod">
                                            {cropping.cultivationMethod.map(items =>
                                                <option key={uuid()} value={items.id}>{items.name}</option>
                                            )}
                                        </Input>
                                    }
                                </FormGroup>
                            </Col>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Cultivation Method For Redrilling</Label>
                                    {cropping.cultivationMethod == undefined && <p><em>Loading...</em></p>}
                                    {cropping.cultivationMethod != undefined && cropping.cultivationMethod != null &&
                                        <Input type="select" value={cropRecordPopup.cultivationMethodRedrilling} onChange={e => setCropRecordPopup({ ...cropRecordPopup, cultivationMethodRedrilling: e.target.value })} name="cultivationMethodRedrilling" id="cultivationMethodRedrilling">
                                            {cropping.cultivationMethod.map(items =>
                                                <option key={uuid()} value={items.id}>{items.name}</option>
                                            )}
                                        </Input>
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row style={{ display: "none" }}>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Time on Crop (Hours/Day)</Label>
                                    <Input type="text" name="timeOnCrop" id="timeOnCrop" value={cropRecordPopup.timeOnCrop} onChange={handleCropRecordItemsChange} onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }} />
                                </FormGroup>
                            </Col>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Stock Type Fed</Label>
                                    {cropping.stockTypeFed == undefined && <p><em>Loading...</em></p>}
                                    {cropping.stockTypeFed != undefined && cropping.stockTypeFed != null &&
                                        <Input type="select" value={cropRecordPopup.stockTypeFed} onChange={e => setCropRecordPopup({ ...cropRecordPopup, stockTypeFed: e.target.value })} name="stockTypeFed" id="stockTypeFed">
                                            {cropping.stockTypeFed.map(items =>
                                                <option key={uuid()} value={items.id}>{items.name}</option>
                                            )}
                                        </Input>
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row style={{ display: "none" }}>

                            <Col sm="6">
                                <FormGroup>
                                    <Label>Month Back into Pasture</Label>
                                    <Select className="dropdown" placeholder="Select Option" value={monthBackIntoPastureListSelectedValues} options={monthBackIntoPastureList} onChange={handleMonthBackIntoPastureChange} isMulti isClearable />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row style={{ display: "none" }}>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>If not returned to pasture, specify what crop is sown</Label>
                                    <Input type="text" name="otherCropSown" id="otherCropSown" value={cropRecordPopup.otherCropSown} onChange={handleCropRecordItemsChange} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12">
                                <FormGroup>
                                    <Label>Indicate all mitigations in place which reduce sediment/soil runoff</Label>
                                    <Input type="textarea" name="mitigationsToReduceSedimentSoilRunoff" id="mitigationsToReduceSedimentSoilRunoff" value={cropRecordPopup.mitigationsToReduceSedimentSoilRunoff} onChange={handleCropRecordItemsChange} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        {(roleName == 'Admin' || isAddEditItem == 'true') &&
                            <>
                                {cropRecordSaving ?
                                    <>
                                        <Button onClick={handleCropRecordSubmit} id="saveCropRecord" color="success" disabled size="sm">
                                            <Row>
                                                <Col sm="6">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="6">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row></Button>{' '}
                                    </>
                                    :
                                    <>
                                        <Button onClick={handleCropRecordSubmit} id="saveCropRecord" color="success" size="sm">
                                            Save
                                        </Button>{' '}
                                    </>
                                }
                            </>
                        }
                        {cropRecordPopup.id !== 0 && <Button color="danger" onClick={(id) => handleCropRecordDeletePopup(cropRecordPopup.id)} size="sm">Delete</Button>}{' '}
                        <Button color="primary" onClick={handleCropRecordPopupClose} size="sm">Cancel</Button>
                    </ModalFooter>
                </Form>
            </Modal>
            {riskSummaryPopup.showriskSummary && <RiskSummary section={cropping.sectionObj} sectionId={cropping.sectionObj.id} riskSummaryPopup={riskSummaryPopup} handleRiskSummaryClose={handleRiskSummaryClose}></RiskSummary>}
            {wholeFarmActionPopup.showActionPopup && <Action width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={cropping.itemList} redirectPage="/cropping" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleWholeActionClose} itemTypeId={wholeFarmActionPopup.itemTypeId} sectionName={cropping.Section} sectionId={cropping.sectionObj.id} itemId={wholeFarmActionPopup.itemId} itemName={wholeFarmActionPopup.itemName}
                showActionPopupModal={wholeFarmActionPopup.showActionPopup} actionId={wholeFarmActionPopup.actionId} itemTypeSelect={cropping.outlineItemTypes} itemTypeDisabled={true} wholeFarmAction={true}></Action>}

        </div>
    )
}
export default Cropping;